import { Button, Checkbox } from "@ad/anq-ui";
import React, { useState } from "react";
import Feature from "./feature";
import Detail from "./detail";
import Mall from "./mall";
import { BANNER_LINK } from "./util";
import styles from "./index.module.scss";
import classNames from "classnames";

interface IProps {
  onClick: () => void;
}
const Agreement = (props: IProps) => {
  const { onClick } = props;
  const [checked, setChecked] = useState(false);

  return (
    <div
      className={classNames(
        "overflow-auto bg-[#E6EEFF] text-center",
        styles.agreementWrapper
      )}
    >
      <img src={BANNER_LINK} alt="banner" className={styles.bannerImage} />
      <Feature />
      <Detail />
      <Mall />
      <footer className={styles.footer}>
        <Button
          type="primary"
          className={styles.button}
          disabled={!checked}
          onClick={onClick}
        >
          已达门槛，立即免费开通
        </Button>
        <div className={styles.agreementInfo}>
          <Checkbox
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          >
            我已阅读并同意
            <a
              target="_blank"
              rel="noreferrer"
              className={styles.link}
              href="https://pfile.pddpic.com/oms_file/2022-11-01/9acbb46034ed4b7bef351940852e1ccb.pdf#view=FitH,top"
            >
              《拼多多数据资产管理系统服务协议》
            </a>
          </Checkbox>
        </div>
      </footer>
    </div>
  );
};

export default Agreement;
